import { ListOptionBase } from "@shared/components";

// Document Status Constants
export interface DocumentStatus {
  statusId: number;
  statusCode: string;
  statusDescription: string;
}

export const DOCUMENT_STATUS: DocumentStatus[] = [
  { statusId: 2, statusCode: "A", statusDescription: "Active" },
  { statusId: 1, statusCode: "P", statusDescription: "Pending" },
  { statusId: 5, statusCode: "W", statusDescription: "Pending Approval" },
  { statusId: 6, statusCode: "V", statusDescription: "Approved" },
];

export const documentStatusOptions: ListOptionBase[] = DOCUMENT_STATUS.map((status) => ({
  id: status.statusCode,
  label: status.statusDescription,
}));

// Document Location Constants
export interface DocumentLocation {
  id: string;
  label: string;
  dbValue: string;
}

export const DOCUMENT_LOCATIONS: DocumentLocation[] = [
  { id: "document", label: "Documents", dbValue: "document" },
  { id: "dataroom", label: "Data Rooms", dbValue: "opportunity" },
  { id: "events", label: "My Calendar", dbValue: "events" },
  { id: "all", label: "Documents and Data Rooms", dbValue: "all" },
  { id: "event-document", label: "Documents and My Calendar", dbValue: "event-document" },
];
export const documentLocationOptions: ListOptionBase[] = DOCUMENT_LOCATIONS.map((location) => ({
  id: location.id,
  label: location.label,
}));

// Helper function to get DB value from location ID
export const getLocationDbValue = (locationId: string): string => {
  const location = DOCUMENT_LOCATIONS.find((loc) => loc.id === locationId);

  return location?.dbValue || locationId;
};

// Helper function to get DB values from location IDs
export const getLocationDbValues = (locationIds: string[]): string[] => {
  return locationIds.map((id) => getLocationDbValue(id));
};

// Helper function to get status ID from status code
export const getStatusIdByCode = (statusCode: string): number | undefined => {
  const status = DOCUMENT_STATUS.find((s) => s.statusCode === statusCode);

  return status?.statusId;
};

// Helper function to get status IDs from status codes
export const getStatusIdsByCodes = (statusCodes: string[]): number[] => {
  return statusCodes.map((code) => getStatusIdByCode(code)).filter((id): id is number => id !== undefined);
};
